export const ColumnResolver = (col) => (rowData) => {
    if (typeof col.value === "function") {
        return col.value(rowData);
    }
    if (typeof col.body === "function") {
        const result = col.body(rowData);
        return typeof result === "string" || typeof result === "number"
            ? result : rowData?.[col.field];
    }
    return rowData?.[col.field] ?? "-";
};